import React from "react";
import {
  NavLink,
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { useView } from "../ResourceViewPage";
import { Box, Button, Container, Typography } from "@mui/material";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { Form } from "../../../Models/SysConf/Form";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import { useQuery } from "react-query";
import { ResourceNames } from "../../../Utils/ResourceNames";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { useSelector } from "react-redux";
import { RoutePath } from "../../../Utils/RoutePath";
import { DataGrid, SelectBox } from "devextreme-react";
import { CustomColumn } from "../../../Models/Project/CustomColumn";
import { Column, Editing, FilterRow } from "devextreme-react/data-grid";
import { ResourceViewField } from "../../../Models/SysConf/ResourceViewField";
import notify from "devextreme/ui/notify";
import { ResourceView } from "../../../Models/SysConf/ResourceView";
import Loader from "../../../Utils/Loader";
import ResourceField from "../../../Models/ResourceField";
import { ResourceViewLink } from "../../../Models/SysConf/ResourceViewLink";

type Props = {};

type ContextType = {
  objEdit: ResourceView;
  setObjEdit: React.Dispatch<React.SetStateAction<ResourceView>>;
};

export default function FieldList(props: Props) {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  // React Router DOM
  const { view, setView } = useView();
  const navigate = useNavigate();
  const location = useLocation();

  //hooks
  const columnsDataGridResourcesViewFields: CustomColumn[] = [
    {
      caption: "Risorsa",
      dataField: "ResourceName",
    },
    {
      caption: "Campo",
      dataField: "FieldName",
    },
  ];
  const [isNewFormVisible, setNewFormVisible] = React.useState<boolean>(false);
  const [isEditFormVisible, setEditFormVisible] =
    React.useState<boolean>(false);
  const [objEdit, setObjEdit] = React.useState<ResourceView | {}>({});
  const [resourceFieldsMain, setResourceFieldsMain] = React.useState<
    ResourceField[]
  >([]);
  const [resourceFieldsLinksName, setResourceFieldsLinksName] = React.useState<
    string[]
  >([]);
  const [resourceFieldLinkName, setResourceFieldLink] = React.useState<
    string | undefined
  >(undefined);
  const [resourceFieldsLinksArray, setResourceFieldsLinksArray] =
    React.useState<ResourceField[]>([]);
  const [isButtonDisabled, setButtonDisabled] = React.useState<boolean>(false);
  const [arrayToSend, setArrayToSend] = React.useState<any[]>([]);
  const [initalView, setInitialView] = React.useState<ResourceView>({
    ...view,
  });

  // Chiamata per togglare la visibilità quando salvao il form di modifica
  React.useEffect(() => {
    if (
      location.pathname ===
      `${RoutePath.RESOURCES_VIEWS}/${view?.View_ID}/field_list`
    ) {
      setEditFormVisible(false);
    }
  }, [location.pathname]);

  // Chiamate API

  // | Chiamate per recuperare i campi della RISORSA COLLEGATA
  const {
    data: resourcesViewsLinks,
    isLoading: isLoadingResourcesViewsLinks,
    isError: isErrorResourcesViewsLinks,
    refetch: refetchResourcesViewsLinks,
    isRefetching: isRefetchingResourcesViewsLinks,
  } = useQuery(
    ["resourcesViewsLinks", view?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsLinks}?RecordSelection=View_ID=${view?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const [resourcesLinkedArraySelected, setResourcesLinkedArraySelected] =
    React.useState<ResourceViewLink[]>([]);

  // Vado a creare un array di stringhe con i nomi delle risorse collegate
  React.useEffect(() => {
    refetchResourcesViewsLinks();
    if (resourcesViewsLinks && resourcesViewsLinks.length > 0) {
      refetchResourcesViewsLinks();
      resourcesViewsLinks.forEach((element: any) => {
        if (
          resourcesLinkedArraySelected.includes(element.ResourceName) === false
        ) {
          resourcesLinkedArraySelected.push(element.ResourceName);
        }
      });
    }
  }, [resourcesViewsLinks]);

  // Chiamata per recuperare i campi della risorsa collegata
  React.useEffect(() => {
    if (resourceFieldLinkName !== undefined) {
      if (resourceFieldLinkName.length > 0) {
        const service = new cubeApiClient();
        service
          .getResourceFieldsByResourceName(resourceFieldLinkName, tokenApi)
          .then((res: any[]) => setResourceFieldsLinksArray(res))
          .catch((err) => console.log(err));
      }
    }
  }, [resourceFieldLinkName]);

  const [arrayTosendLinks, setArrayToSendLinks] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (resourceFieldsLinksArray.length > 0) {
      const arrayToTest = resourceFieldsLinksArray.map((rf) => {
        return {
          View_ID: view?.View_ID,
          ResourceField_ID: rf.ResourceField_ID,
          ResourceName: rf.ResourceName,
          FieldName: rf.FieldName,
        };
      });
      setArrayToSendLinks(arrayToTest);
    }
  }, [resourceFieldsLinksArray]);

  React.useEffect(() => {
    if (arrayTosendLinks.length > 0) {
      const service = new cubeApiClient();
      service
        .updateObjects(
          arrayTosendLinks,
          `api/sys/${ResourceNames.ResourcesViewsFields}`,
          tokenApi
        )
        .then((data) => {
          refetchResourcesViewsFields();
          notify("Campi salvati con successo", "success", 1000);
        })
        .catch((error) => {
          refetchResourcesViewsFields();
          notify("Errore nel salvataggio dei campi", "error", 1000);
        });
    }
  }, [arrayTosendLinks]);

  // Chiamata per recuperare i campi della risorsa principale per ResourceName
  const getResoRearceFieldsByResourceName = () => {
    setButtonDisabled(true);
    const service = new cubeApiClient();
    service
      .getResourceFieldsByResourceName(view?.ResourceName, tokenApi)
      .then((res: any[]) => setResourceFieldsMain(res))
      .catch((err) => console.log(err));
  };

  // Chiamata per recuperare i resourcesViewsFields
  const {
    data: resourcesViewsFields,
    isLoading: isLoadingResourcesViewsFields,
    isError: isErrorResourcesViewsFields,
    refetch: refetchResourcesViewsFields,
    isRefetching: isRefetchingResourcesViewsFields,
  } = useQuery(
    ["resourcesViewsFields", view?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsFields}?RecordSelection=View_ID=${view?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  // Chiamata per recuperare i form dei resourcesViewsFields
  const {
    data: formResourcesViewsFields,
    isLoading: isLoadingFormResourcesViewsFields,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsFields,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsFields}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewField: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsFields) {
      let tmpForm: Form = formResourcesViewsFields;

      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsFields]);

  // Formatto i campi facendo dopo averli recuperati completamente con il ResourceName, successivamente li mappo e aggiungo il view_ID
  React.useEffect(() => {
    if (resourceFieldsMain.length > 0) {
      const arrayToTest = resourceFieldsMain.map((rf) => {
        return {
          View_ID: view?.View_ID,
          ResourceField_ID: rf.ResourceField_ID,
          ResourceName: rf.ResourceName,
          FieldName: rf.FieldName,
        };
      });
      setArrayToSend(arrayToTest);
    }
  }, [resourceFieldsMain]);

  // Chiamata per salvare i campi dopo averli mappatai e formattati come richiede il BackEnd
  React.useEffect(() => {
    if (arrayToSend.length > 0) {
      const service = new cubeApiClient();
      service
        .updateObjects(
          arrayToSend,
          `api/sys/${ResourceNames.ResourcesViewsFields}`,
          tokenApi
        )
        .then((data) => {
          refetchResourcesViewsFields();
          notify("Campi salvati con successo", "success", 1000);
        })
        .catch((error) => {
          refetchResourcesViewsFields();
          notify("Errore nel salvataggio dei campi", "error", 1000);
        })
        .finally(() => {
          setButtonDisabled(false);
        });
    }
  }, [arrayToSend]);

  // Chiamata per eliminare un campo
  const deleteResourceViewField = (e: ResourceViewField) => {
    const service = new cubeApiClient();

    service
      .deleteObject(
        e,
        `api/sys/${ResourceNames.ResourcesViewsFields}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsFields();
          notify("Campo eliminato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsFields();
          notify("Errore nell'eliminazione del campo", "error", 1000);
        }
      );
  };

  // Chiamata per salvare un nuovo campo
  const saveNewResourceViewField = () => {
    refetchResourcesViewsFields();
    const service = new cubeApiClient();

    service
      .updateObject(
        view,
        `api/sys/${ResourceNames.ResourcesViewsFields}`,
        tokenApi
      )
      .then(
        (data) => {
          setNewFormVisible(false);
          refetchResourcesViewsFields();
          notify("Campo salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsFields();
          notify("Errore nel salvataggio del campo", "error", 1000);
        }
      );
  };

  // ! Inizio del DOM
  return (
    <>
      <Typography
        variant="h6"
        color={"primary.main"}
        style={{ fontWeight: 600, textAlign: "center" }}
        className="pt-3"
      >
        ELENCO CAMPI
      </Typography>

      {view === undefined ||
      view === null ||
      resourcesViewsFields === undefined ||
      resourcesViewsFields === null ? (
        <Loader />
      ) : (
        <Container maxWidth="lg" sx={{ mt: 5 }}>
          {/* Bottone aggiungi, visulizzo il form e devisualizzo la DataGrid */}
          {!isNewFormVisible && !isEditFormVisible && (
            <Box
              sx={{
                mb: 3,
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              {resourcesLinkedArraySelected.length > 0 && (
                <SelectBox
                  dataSource={resourcesLinkedArraySelected}
                  placeholder="Seleziona una risorsa"
                  onValueChanged={(e) => {
                    setResourceFieldLink(e.value);
                  }}
                />
              )}

              <Button
                variant="contained"
                className="me-2"
                onClick={getResoRearceFieldsByResourceName}
                disabled={isButtonDisabled ? true : false}
              >
                Campi Risorsa Principale
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setNewFormVisible(true);
                  setView(initalView);
                }}
              >
                Aggiungi
              </Button>
            </Box>
          )}

          {/* Box con DataGrid al mounted o eventuale form di aggiunta */}
          <Box sx={{ width: "100%", height: "100%", mb: 2 }}>
            {!isNewFormVisible ? (
              <>
                {!isEditFormVisible ? (
                  <DataGrid
                    className="mb-5"
                    dataSource={resourcesViewsFields || []}
                    showBorders={true}
                    showRowLines={true}
                    showColumnLines={true}
                    onRowRemoved={(e) => {
                      deleteResourceViewField(e.data as ResourceViewField);
                    }}
                    onEditingStart={(e) => {
                      setObjEdit(e.data);
                      setEditFormVisible(true);
                      navigate("edit");
                    }}
                  >
                    <FilterRow visible={true} />
                    {columnsDataGridResourcesViewFields.map(
                      (column: CustomColumn, i: number) => (
                        <Column
                          key={i}
                          dataField={column.dataField}
                          caption={column.caption}
                        />
                      )
                    )}
                    <Editing
                      allowUpdating={true}
                      allowDeleting={true}
                      confirmDelete={true}
                      useIcons={true}
                      startEditAction="click"
                    />
                  </DataGrid>
                ) : (
                  <Outlet context={{ objEdit, setObjEdit }} />
                )}
              </>
            ) : (
              <RenderFormNew
                showTitle={false}
                form={formResourceViewField}
                isNew={true}
                myObj={view}
                saveNewObject={(e) => {
                  setView(e);
                }}
              />
            )}

            {isNewFormVisible ? (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  flexDirection: "row",
                }}
              >
                {/* Bottone di Anulla, mi riporta alla DataGrid */}
                <Button
                  variant="contained"
                  color="error"
                  className="me-2"
                  onClick={() => setNewFormVisible(false)}
                >
                  Annulla
                </Button>

                {/* Bottone salva */}
                <Button
                  variant="contained"
                  color="success"
                  onClick={() => saveNewResourceViewField()}
                >
                  Salva
                </Button>
              </Box>
            ) : (
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  mt: 1,
                  flexDirection: "row",
                }}
              >
                {/* Bottone di Anulla, mi riporta al form iniziale */}
                {!isNewFormVisible && !isEditFormVisible && (
                  <>
                    <NavLink
                      to={`${RoutePath.RESOURCES_VIEWS}/${view.View_ID}`}
                    >
                      <Button
                        variant="contained"
                        color="error"
                        className="me-2"
                        onClick={() => setNewFormVisible(false)}
                      >
                        Torna Indietro
                      </Button>
                    </NavLink>

                    {/* Bottone salva, mi riporta alla home*/}
                    <NavLink to={RoutePath.RESOURCES_VIEWS}>
                      <Button variant="contained" color="success">
                        Torna alla griglia
                      </Button>
                    </NavLink>
                  </>
                )}
              </Box>
            )}
          </Box>
        </Container>
      )}
    </>
  );
}

export function useFieldObjEdit() {
  return useOutletContext<ContextType>();
}
